<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <Floor-form ref="realForm" @ok="submitCallback"  :from="from" :disabled="disableSubmit"></Floor-form>
  </j-modal>
</template>

<script>

  import FloorForm from './FloorForm.vue';
  export default {
    name: 'FloorModal',
    components: {
      FloorForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        sysvenueid:'',
        sysactivityid:'',
        parent:{},
      }
    },
    props: {
    //表单禁用
    from: {
      type: String,
      default: '',
      required: false
    }
  },
    methods: {
      refreshTree()
      {
        this.$emit('refreshTree');
      },
      add () {
        var that =this;
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.model.sysvenueid=this.sysvenueid;
          this.$refs.realForm.model.sysactivityid=this.sysactivityid;
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },

      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>